import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";

import Marketing from "./pages/Marketing";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import PublicBooking from "./pages/PublicBooking";
import BookingConfirm from "./pages/BookingConfirm";
import Dashboard from "./pages/crm/Dashboard";
import Appointments from "./pages/crm/Appointments";
import Clients from "./pages/crm/Clients";
import ClientDetail from "./pages/crm/ClientDetail";
import Waitlist from "./pages/crm/Waitlist";
import Services from "./pages/crm/Services";
import Team from "./pages/crm/Team";
import Messages from "./pages/crm/Messages";
import Billing from "./pages/crm/Billing";
import Settings from "./pages/crm/Settings";

const staff = ["owner", "receptionist", "stylist"];
const manager = ["owner", "receptionist"];

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Marketing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/book/:slug" element={<PublicBooking />} />
            <Route path="/book/:slug/confirm" element={<BookingConfirm />} />
            <Route path="/dashboard" element={<ProtectedRoute roles={staff}><Dashboard /></ProtectedRoute>} />
            <Route path="/appointments" element={<ProtectedRoute roles={staff}><Appointments /></ProtectedRoute>} />
            <Route path="/clients" element={<ProtectedRoute roles={staff}><Clients /></ProtectedRoute>} />
            <Route path="/clients/:id" element={<ProtectedRoute roles={staff}><ClientDetail /></ProtectedRoute>} />
            <Route path="/waitlist" element={<ProtectedRoute roles={staff}><Waitlist /></ProtectedRoute>} />
            <Route path="/services" element={<ProtectedRoute roles={manager}><Services /></ProtectedRoute>} />
            <Route path="/team" element={<ProtectedRoute roles={["owner"]}><Team /></ProtectedRoute>} />
            <Route path="/messages" element={<ProtectedRoute roles={staff}><Messages /></ProtectedRoute>} />
            <Route path="/billing" element={<ProtectedRoute roles={["owner"]}><Billing /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute roles={["owner"]}><Settings /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
